import { gql } from "@apollo/client";
import { Organization } from "@App/types";

export interface ServicesQuery {
  organization: Organization;
}

export const GET_SERVICES = gql`
    query getServices($organization:ID!, $service: ID, $slug: String) {
        organization(id: $organization) {
            id
            services(id: $service, slug: $slug) {
                id
                uuid
                name
                slug
                garage_prefix
                show_checkpoint
                display_reviews
                requires_additional_information
                pivot {
                    subtitle
                    icon
                    display_name
                    display_search_headline
                    display_image_placeholder
                    sort_order
                    reviews_enabled
                    faqs {
                        headline
                        content
                    }
                    external_url
                }
            }
        }
    }
`;
